import React from 'react';
import Form from 'containers/PasswordRecoveryPages/PinMethodForgotPassword/Form';
import { connect } from 'react-redux';
import {
  forgetPasswordEmail,
  setPasswordRecoveryStep,
} from 'store/credentials/actions';
import { CHOOSE_METHODS_RECOVERY_PASS } from 'containers/PasswordRecoveryPages/constants';
import Header from 'containers/PasswordRecoveryPages/Header';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/PasswordRecoveryPages/PinMethodForgotPassword/messages';
import { translate } from 'helpers/intl';
import {
  getErrorMessageSelector,
  getHashedEmailSelector,
  getHashedPhoneSelector,
  getIsEmailSelector,
  getIsQuestionSelector,
} from 'store/credentials/selectors';
import { createStructuredSelector } from 'reselect';

const PinMethodForgotPassword = ({
  setPasswordRecoveryStep,
  onSubmitStep,
  isLoading,
  hashedEmail,
  hashedPhone,
  showEmailOption,
  showQuestionOption,
  errorMessage,
  forgetPasswordEmail,
  ...otherProps
}: {
  setPasswordRecoveryStep: Function;
  onSubmitStep: Function;
  isLoading: Boolean;
  intl: IntlShape;
  hashedEmail: string;
  errorMessage: string;
  hashedPhone: string;
  showEmailOption: boolean;
  showQuestionOption: boolean;
  forgetPasswordEmail: Function;
}) => {
  return (
    <React.Fragment>
      <Header
        title={translate(messages.formTitle, otherProps)}
        subTitle={translate(
          showEmailOption ? messages.formSubTitle : messages.formSubTitlePhone,
          otherProps,
        )}
      />
      <Form
        onSubmitStep={onSubmitStep}
        proceedDifferently={() =>
          setPasswordRecoveryStep(CHOOSE_METHODS_RECOVERY_PASS)
        }
        isLoading={isLoading}
        hashedEmail={hashedEmail}
        hashedPhone={hashedPhone}
        showEmailOption={showEmailOption}
        errorMessage={errorMessage}
        forgetPasswordEmail={forgetPasswordEmail}
        showQuestionOption={showQuestionOption}
      />
    </React.Fragment>
  );
};

const mapPropsToProps = createStructuredSelector<
  any,
  {
    hashedEmail: string;
    errorMessage: string;
    showEmailOption: boolean;
    hashedPhone: string;
    showQuestionOption: boolean;
  }
>({
  errorMessage: getErrorMessageSelector,
  hashedEmail: getHashedEmailSelector,
  hashedPhone: getHashedPhoneSelector,
  showEmailOption: getIsEmailSelector,
  showQuestionOption: getIsQuestionSelector,
});
const mapDispatchToProps = {
  setPasswordRecoveryStep,
  forgetPasswordEmail,
};
export default connect(
  mapPropsToProps,
  mapDispatchToProps,
)(injectIntl(PinMethodForgotPassword));
export { PinMethodForgotPassword };
